import React from "react";
import { Link } from "react-router-dom";
import amirKhanImg from "../assets/team/AmirKhan.png";
import mohamedUmarImg from "../assets/team/MohamedUmar.jpg";
import skJumunaImg from "../assets/team/SKJumuna.png";

/* ─── Team data ────────────────────────────────────────────────── */
const TEAM = [
  {
    id: 1,
    name: "Mohamed Umar",
    role: "General Manager",
    image: mohamedUmarImg,
    facebook: "#",
    twitter: "#",
    youtube: "#",
  },
  {
    id: 2,
    name: "Amir Khan",
    role: "Chef",
    image: amirKhanImg,
    facebook: "#",
    twitter: "#",
    youtube: "#",
  },
  {
    id: 3,
    name: "SK Jumuna",
    role: "Chef",
    image: skJumunaImg,
    facebook: "#",
    twitter: "#",
    youtube: "#",
  },
];

/* ─── Social Icon SVGs ─────────────────────────────────────────── */
const FacebookIcon = () => (
  <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 24 24">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

const XIcon = () => (
  <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 24 24">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const YoutubeIcon = () => (
  <svg className="w-3.5 h-3.5 fill-current" viewBox="0 0 24 24">
    <path d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z" />
  </svg>
);

/* ─── Team Card ────────────────────────────────────────────────── */
const TeamCard = ({ member }) => (
  <article className="group flex flex-col bg-[#f5ede4] overflow-hidden">
    {/* Image wrapper */}
    <div className="relative overflow-hidden">
      <img
        src={member.image}
        alt={member.name}
        className="w-full h-[320px] object-cover object-top transition-transform duration-500 group-hover:scale-105"
      />

      {/* Social icons bar — overlaid at bottom of image */}
      <div className="absolute bottom-0 left-0 right-0 flex justify-center gap-2 p-3 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <a
          href={member.facebook}
          aria-label={`${member.name} Facebook`}
          className="w-8 h-8 bg-[#9b1c2e] hover:bg-[#7d1624] text-white flex items-center justify-center transition-colors duration-200"
          onClick={(e) => e.stopPropagation()}
        >
          <FacebookIcon />
        </a>
        <a
          href={member.twitter}
          aria-label={`${member.name} X`}
          className="w-8 h-8 bg-[#9b1c2e] hover:bg-[#7d1624] text-white flex items-center justify-center transition-colors duration-200"
          onClick={(e) => e.stopPropagation()}
        >
          <XIcon />
        </a>
        <a
          href={member.youtube}
          aria-label={`${member.name} YouTube`}
          className="w-8 h-8 bg-[#9b1c2e] hover:bg-[#7d1624] text-white flex items-center justify-center transition-colors duration-200"
          onClick={(e) => e.stopPropagation()}
        >
          <YoutubeIcon />
        </a>
      </div>

      {/* Always-visible social bar on mobile */}
      <div className="sm:hidden absolute bottom-0 left-0 right-0 flex justify-center gap-2 p-3">
        <a href={member.facebook} aria-label="Facebook" className="w-8 h-8 bg-[#9b1c2e] text-white flex items-center justify-center">
          <FacebookIcon />
        </a>
        <a href={member.twitter} aria-label="X" className="w-8 h-8 bg-[#9b1c2e] text-white flex items-center justify-center">
          <XIcon />
        </a>
        <a href={member.youtube} aria-label="YouTube" className="w-8 h-8 bg-[#9b1c2e] text-white flex items-center justify-center">
          <YoutubeIcon />
        </a>
      </div>
    </div>

    {/* Name & Role */}
    <div className="text-center py-5 px-4">
      <h3 className="text-[18px] font-bold text-gray-900 tracking-wide">
        {member.name}
      </h3>
      <p className="font-sans text-[11px] font-bold uppercase tracking-[0.2em] text-[#9b1c2e] mt-1">
        {member.role}
      </p>
    </div>
  </article>
);

/* ─── Team Section ─────────────────────────────────────────────── */
const TeamSection = () => (
  <section id="team" className="py-20 bg-white">
    <div className="max-w-[1280px] mx-auto px-4 lg:px-8">

      {/* ── Section Header Row ── */}
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12">
        <div>
          <p className="font-sans text-[11px] font-bold tracking-[0.25em] text-[#9b1c2e] uppercase mb-3">
            Team
          </p>
          <h2 className="text-[30px] sm:text-[38px] font-bold text-gray-900 leading-tight uppercase tracking-wide max-w-md">
            Meet the Culinary
            <br />
            Experts Behind Barbequeen
          </h2>
        </div>

        <Link
          to="/team"
          className="font-sans flex-shrink-0 inline-flex items-center gap-2 px-6 py-3 bg-[#9b1c2e] hover:bg-[#7d1624] text-white text-[12px] font-bold tracking-widest uppercase transition-colors duration-200 self-start sm:self-auto"
        >
          See All Team
        </Link>
      </div>

      {/* ── Cards Grid ── */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {TEAM.map((member) => (
          <TeamCard key={member.id} member={member} />
        ))}
      </div>

    </div>
  </section>
);

export default TeamSection;

